<script>
  import BlockGlobal from "./BlockGlobal.svelte";
  import TextBlock from "./TextBlock.svelte";
  import {M} from "../../external";
  import Checkbox from "../../Common/Checkbox.svelte";

  export let data;

  $: if (typeof data.includeAddressInfo === "undefined") data.includeAddressInfo = true;
</script>

<TextBlock heading="{M.HEADING_WIDGET_NAME} 1" bind:data={data.heading1} isCollapsable={true} isCollapsed={true}/>
<TextBlock heading="{M.HEADING_WIDGET_NAME} 2" bind:data={data.heading2} isCollapsable={true} isCollapsed={true}/>
<TextBlock heading="{M.TEXT_WIDGET_NAME}" bind:data={data.body} isCollapsable={true} isCollapsed={true}/>
<Checkbox bind:data={data.includeAddressInfo} label="{M.INCLUDE_CUSTOMER_SELLER_DETAILS}"/>
<BlockGlobal bind:data isCollapsable={true} isCollapsed={true} />
